import getImageUrl from "./get-image-url";

const currentEnv = process.env.HOST_ENV;

export const imageTypes = {
    desktopCarCard: "desktopCarCard",
    desktopCarouselImage: "desktopCarouselImage",
    inspectionPreview: "inspectionPreview",
    desktopInspectionImage: "desktopInspectionImage",
    inspectionThumbnail: "inspectionThumbnail",
    makeAnOfferThumbnail: "makeAnOfferThumbnail",
    mobileCarDetailImage: "mobileCarDetailImage",
    inspectionPreviewThumbnail: "inspectionPreviewThumbnail",
    mobileCarDetailZoomable: "mobileCarDetailZoomable",
    mobileMakeAnOfferThumbnail: "mobileMakeAnOfferThumbnail",
    carService: "carService",
    carServiceThumbnail: "carServiceThumbnail",
    carDetailHeroImage: "carDetailHeroImage",
    newInspectionThumbnail: "newInspectionThumbnail",
    appstoreIcon: "appstoreIcon",
    gsCarCard: "gsCarCard",
    gsCarCard360: "gsCarCard360",
    default: "default",
    spinCarPreview: "spinCarPreview",
    spinCarZoomable: "spinCarZoomable",
    aeCarDetailPreview: "aeCarDetailPreview",
    auCarDetailPreview: "auCarDetailPreview",
    gsCarCardAU: "gsCarCardAU",
    helloARCarCardAu: "helloARCarCardAu",
    auCarCheckoutThumbnail: "auCarCheckoutThumbnail",
    auCarTaskImage: "auCarTaskImage",
    auCarHeaderIcon: "auCarHeaderIcon",
    nudges: "nudges",
    gsCarCardDesktop: "gsCarCardDesktop",
    gsCarCardAUExpand: "gsCarCardAUExpand",
    helloARCarCardAuExpand: "helloARCarCardAuExpand",
    gsCarCompareHeaderCard: "gsCarCompareHeaderCard",
    cdpSliderRevamp: "cdpSliderRevamp",
    galleryRevamp: "galleryRevamp",
    orderSummaryCar: "orderSummaryCar",
    atfCategoryThumbnail: "atfCategoryThumbnail",
    listingIcon: "listingIcon",
    rwcHeaderMsite: "rwcHeaderMsite",
    threeHundredPointInspection: "threeHundredPointInspection",
    whyCars24Card: "whyCars24Card",
    rwcHeaderDesktop: "rwcHeaderDesktop",
    postBcTaskCard: "postBcTaskCard",
    premiumFeatures: "premiumFeatures",
    dealerHeader: "dealerHeader",
    dealerSubHeader: "dealerSubHeader",
    dealerHeaderDesktop: "dealerHeaderDesktop",
    dealerSubHeaderDesktop: "dealerSubHeaderDesktop",
    locationSelection: "locationSelection",
    imperfectionMobileSliderImage: "locationSelection",
    comingSoonMobile: "comingSoonMobile"
};

export const imageProps = {
    [imageTypes.desktopCarCard]: { fastly: { w: 260, h: 188, auto: "format" } },
    [imageTypes.desktopCarouselImage]: { fastly: { w: 720, auto: "format" } },
    [imageTypes.inspectionPreview]: { fastly: { w: 58, h: 38, auto: "format" }, fit: "crop" },
    [imageTypes.desktopInspectionImage]: { fastly: { w: 710, h: 400, auto: "format", fit: "crop" } },
    [imageTypes.inspectionThumbnail]: { fastly: { w: 80, h: 60, auto: "format" } },
    [imageTypes.makeAnOfferThumbnail]: { fastly: { w: 152, h: 96, auto: "format" } },
    [imageTypes.mobileCarDetailImage]: { fastly: { w: 373, h: 300, auto: "format" } },
    [imageTypes.inspectionPreviewThumbnail]: { fastly: { w: 58, h: 36, auto: "format" }, fit: "crop" },
    [imageTypes.newInspectionThumbnail]: { fastly: { w: 146, h: 146, auto: "format" }, fit: "crop" },
    [imageTypes.mobileCarDetailZoomable]: { fastly: { w: 1080, auto: "format" } },
    [imageTypes.mobileMakeAnOfferThumbnail]: { fastly: { w: 80, h: 50, auto: "format" } },
    [imageTypes.carService]: { fastly: { w: 414, h: 180, fit: "crop",  auto: "format" } },
    [imageTypes.carServiceThumbnail]: { fastly: { w: 80, h: 80, fit: "crop", auto: "format" } },
    [imageTypes.appstoreIcon]: { fastly: { h: 39, auto: "format" } },
    [imageTypes.default]: { fastly: { auto: "format" } },
    [imageTypes.gsCarCard]: { fastly: { w: 397, auto: "format", format: "jpeg", quality: 55 } },
    [imageTypes.gsCarCardDesktop]: { fastly: { w: 397, auto: "format" } },
    [imageTypes.spinCarPreview]: { fastly: { w: 375, auto: "format" } },
    [imageTypes.spinCarZoomable]: { fastly: { w: 1080, auto: "format" } },
    [imageTypes.gsCarCard360]: { fastly: { w: 345, auto: "format" } },
    [imageTypes.aeCarDetailPreview]: { fastly: { w: 700, auto: "format" } },
    [imageTypes.auCarDetailPreview]: { fastly: { w: 700, auto: "format", dpr: 2 } },
    [imageTypes.auCarDetailThumbnail]: { fastly: { w: 128, auto: "format" } },
    [imageTypes.auNudgesSmall]: { fastly: { w: 48, h: 48, auto: "format" } },
    [imageTypes.auNudgesMedium]: { fastly: { w: 152, auto: "format"} },
    [imageTypes.gsCarCardAU]: { fastly: { w: 397, crop: "1600,900,x150,y200", auto: "format" } },
    [imageTypes.helloARCarCardAu]: { fastly: { w: 397, auto: "format" } },
    [imageTypes.auCarCheckoutThumbnail]: { fastly: { w: 132, auto: "format" } },
    [imageTypes.auCarHeaderIcon]: { fastly: { w: 30, auto: "format" } },
    [imageTypes.auCarTaskImage]: { fastly: { w: 42, crop: "500,700,x1050,y300" } },
    [imageTypes.gsCarCardAUExpand]: { fastly: { w: 800, crop: "1600,900,x150,y200", auto: "format" } },
    [imageTypes.helloARCarCardAuExpand]: { fastly: { w: 800, auto: "format" } },
    [imageTypes.gsCarCompareHeaderCard]: { fastly: { w: 320, h: 200, auto: "format" } },
    [imageTypes.carDetailHeroImage]: {fastly: {w: 1035, auto: "format", dpr: 2}},
    [imageTypes.cdpSliderRevamp]: { fastly: { w: 136, auto: "format" } },
    [imageTypes.galleryRevamp]: { fastly: { w: 650, auto: "format" } },
    [imageTypes.orderSummaryCar]: { fastly: { w: 193, h: 117, fit: "crop", auto: "format" } },
    [imageTypes.atfCategoryThumbnail]: { fastly: { w: 185, h: 150, fit: "crop", auto: "format" }},
    [imageTypes.listingIcon]: { fastly: { w: 16, h: 16, fit: "crop", auto: "format" }},
    [imageTypes.rwcHeaderMsite]: { fastly: { w: 360, h: 400, auto: "format" }},
    [imageTypes.threeHundredPointInspection]: { fastly: { w: 493, h: 380, auto: "format" }},
    [imageTypes.whyCars24Card]: { fastly: { w: 354, h: 422, auto: "format" }},
    [imageTypes.rwcHeaderDesktop]: { fastly: { w: 1400, auto: "format" }},
    [imageTypes.postBcTaskCard]: { fastly: { w: 100, h: 70, auto: "format" }},
    [imageTypes.premiumFeatures]: { fastly: { w: 272, h: 160, auto: "format", dpr: 2 }},
    [imageTypes.dealerHeader]: { fastly: { w: 300, auto: "format", dpr: 2 }},
    [imageTypes.dealerSubHeader]: { fastly: { w: 100, auto: "format", dpr: 2 }},
    [imageTypes.dealerHeaderDesktop]: { fastly: { w: 700, auto: "format", dpr: 2 }},
    [imageTypes.dealerSubHeaderDesktop]: { fastly: { w: 500, auto: "format", dpr: 2 }},
    [imageTypes.comingSoonMobile]: { fastly: { w: 500, auto: "format", dpr: 2 }},
    [imageTypes.locationSelection]: { fastly: { w: 400, auto: "format" }},
    [imageTypes.imperfectionMobileSliderImage]: { fastly: { w: 400, auto: "format" }}
};

export const cdnBaseUrl = () => {
    const cdns = {
        QA: "https://fastly-production.24c.in",
        // STAGING: "https://cars24-staging.imgix.net",
        STAGING: "https://thumbor-staging.24c.in/",
        // STAGING: "https://aetjsvueep.cloudimg.io/v7",
        // PRODUCTION: "https://cars24-production.imgix.net",
        PRODUCTION: "https://fastly-production.24c.in"
        // PRODUCTION: "https://agbugvxsyp.cloudimg.io/v7"
    };
    return cdns[currentEnv];
};

export const propsBuilder = (url, imageProperties) => {
    const finalUrl = [url];
    const properties = Object.keys(imageProperties).reduce((pv, cv) => {
        if (imageProperties[cv] && cv !== "thumborProps" && cv !== "thumbor" && cv !== "baseUrl" && cv !== "fitIn" && cv !== "size") {
            return [...pv, `${cv}=${imageProperties[cv]}`];
        }
        return pv;
    }, []);
    finalUrl.push(properties.join("&"));
    return finalUrl.join("?");
};

export const fastlyUrl = (basePath, path, type) => {
    const urlParts = [[basePath, path].join("")];
    return propsBuilder(urlParts.join("/"), {
        ...imageProps[type].fastly
    });
};

export const cdnImageUrl = (url, type, imageProperties = {}) => {
    const currentPath = cdnBaseUrl();
    if ((currentEnv === "STAGING" || imageProperties.useThumbor === true)) {
        return getImageUrl(url, {
            ...imageProps[type].thumbor,
            ...imageProperties.thumborProps

        });
    }
    const cdnType = (currentEnv === "PRODUCTION") ? "fastly" : "thumbor";
    const urlParts = [currentPath];
    urlParts.push(url);
    return propsBuilder(urlParts.join("/"), {
        ...imageProps[type][cdnType],
        ...imageProperties
    });
};

export const getFastlyImageFromAbsoluteImageUrl = (url, type) => {
    return propsBuilder(url, {
        ...imageProps[type].fastly
    });
};
